export interface CamaraG {
  Id: number,
  id_camara?: string,
  Id_camara?: string,
  estadoConexion?: string,
  nombre: string,
  IdSoporte: string,
  modelo: string,
  marca: string,
  Ip: string,
  calle: string,
  Soporte: string,
  Altura: string,
  GradosOrientacion: any,
  Entorno: string,
  Titulo: string,
  posicion: string,
  estadoDialogo: string,
  Modificar: string,
  DatosOriginales: any,
  IdTipoCamara: any,
  tipoDeteccion: any,
  TipoCamara: any,
  Activa: number,
  Latitud: string,
  Longitud: string,
  alcanceCoordenadas: string;
  parking: string;
  ahorro_consumo: number;
  totalRegistros?: number;
  peatones_lineas?: boolean;
  conteo_bicis?: boolean;
  Nombre_zona_lineas?: string;
  timelapse?: boolean;
  metadata_support_image?: string;
  id_subtipo?: number;
  nombre_subtipo?: string;
}

export interface DialogoReproductorModel {
  id_camara: string,
  titulo: string,
  ip: string,
  camaras: any,
  Posicion: any,
  TipoCamara: any,
}

export interface CamaraValida {
  Id: string,
  Ip: string
}

export interface CamaraValida2 {
  estado: string,
  mensaje: string
}

export interface ListImagenes {
  archivo: string,
  Fecha_imagen: any,
  Hora_procesado: any
}

export interface CameraGroup {
  id: number;
  id_camara: string;
  nombre: string;
  ip: string;
  TipoCamara: string;
  IdSoporte: number;
  calle: string;
  Municipio?: string;
  IdMunicipio?: string; 
  Descripcion?: string;
  idTipoCamara?: string;
  id_subtipo?: number | null;
}

export interface CameraVisor {
  id: number;
  id_camara: string;
  nombre: string;
  FechaImagenFormato?: string;
  Fecha_imagen?: string;
  Fecha_imagen_utc?: string;
  TipoCamara?: number;
  archivo?: string;
  estado?: string;
  fechaBusquedaantes?: string;
  fechaBusquedadespues20?: string;
  fechaBusquedadespues70?: string;
  fechaantes?: string;
  fechadespues20?: string;
  fechadespues70?: string;
  ip?: string;
  url?: string;
  isStream?: boolean;
  stopCam?: boolean;
  activado?: string;
}

export interface CameraAccountSelectedPerson {
  id: number;
  id_camera: string;
  name: string;
  checked: boolean;
  coefficient?: number;
}

export interface InfoCameraAndSupportLocation {
  id: number;
  id_camara: string;
  nombre: string;
  ip: string;
  IdSoporte: number;
  calle: string;
  Descripcion: string;
  Latitud: string;
  Longitud: string;
}

export interface PedestrianZone {
  Id: number;
  id_camara: string;
  nombre: string;
  Nombre_zona_lineas: string;
  Nombre_grupo_zonas: string;
  coeficiente?: number;
}

/**
 * Modelo de datos para el listado de archivos que devuelve el api stream
 */

export interface ListFileCamera {
  data: DataCamera;
  status: number;
}

export interface DataCamera {
  CMSearchResult?: CMSearchResult;
  config?: Config;
}

interface CMSearchResult {
  '$': Version;
  searchID: string[];
  responseStatus: string[];
  responseStatusStrg: string[];
  numOfMatches: string[];
  matchList: MatchList[];
}

interface MatchList {
  searchMatchItem: SearchMatchItem[];
}

interface SearchMatchItem {
  sourceID: string[];
  trackID: string[];
  timeSpan: TimeSpan[];
  mediaSegmentDescriptor: MediaSegmentDescriptor[];
  metadataMatches: MetadataMatch[];
}

interface MetadataMatch {
  metadataDescriptor: string[];
}

interface MediaSegmentDescriptor {
  contentType: string[];
  codecType: string[];
  playbackURI: string[];
}

interface TimeSpan {
  startTime: string[];
  endTime: string[];
}

interface Version {
  version: string;
  xmlns: string;
}

export interface Config {
  $: GeneratedType
  timesectionList: TimesectionList[]
}

export interface GeneratedType {
  version: string
  xmlns: string
}

export interface TimesectionList {
  $: GeneratedType2
  item: Item[]
}

export interface GeneratedType2 {
  type: string
  maxCount: string
  count: string
}

export interface Item {
  starttime: Starttime[]
  endtime: Endtime[]
  playbackURI: PlaybackUri[]
}

export interface Starttime {
  _: string
  $: GeneratedType3
}

export interface GeneratedType3 {
  type: string
  seconds: string
  recType: string
}

export interface Endtime {
  _: string
  $: GeneratedType4
}

export interface GeneratedType4 {
  type: string
}

export interface PlaybackUri {
  _: string
  $: GeneratedType5
}

export interface GeneratedType5 {
  type: string
}
export interface Config {
  $: GeneratedType
  timesectionList: TimesectionList[]
}

export interface GeneratedType {
  version: string
  xmlns: string
}

export interface TimesectionList {
  $: GeneratedType2
  item: Item[]
}

export interface GeneratedType2 {
  type: string
  maxCount: string
  count: string
}

export interface Item {
  starttime: Starttime[]
  endtime: Endtime[]
  playbackURI: PlaybackUri[]
}

export interface Starttime {
  _: string
  $: GeneratedType3
}

export interface GeneratedType3 {
  type: string
  seconds: string
  recType: string
}

export interface Endtime {
  _: string
  $: GeneratedType4
}

export interface GeneratedType4 {
  type: string
}

export interface PlaybackUri {
  _: string
  $: GeneratedType5
}

export interface GeneratedType5 {
  type: string
}

export enum TypeStorageByGetUrlImage {
  LPR = 'lpr',
  MDATA = 'mdata',
  MOVES = 'moves',
  STATIC = 'static',
  MULTAS = 'multas',
  OTROS = 'otros'
}

export enum NameContainersAvailable {
  metadatos = 'metadatos'
}

export interface SubtypeCamera {
  id_subtipo: number;
  id_tipo: number;
  nombre: string;
  descripcion: string;
  tipoCamara?: string;
}